import './gallery.js'
import './suggestion-form.js'
import './newsletter-popup.js'
// TODO: Move progress bar to a more generic location since this file is only loaded on article profiles
import './progress-bar.js'
import './trackers.js'
import './story-gallery.js'
import './card-element.js'
import { on } from '@utils/events.js'
import { showBlind } from '@utils/animation.js'
import { checkVisibility } from '@utils/html.js'
import { initStickyQuickLinks } from '@/es6/src/views/article/quick-links.js'

if (document.querySelector('[data-open-article-table-of-contents]')) {
    on('click', document, '[data-open-article-table-of-contents]', (e) => {
        e.preventDefault()

        const toc = document.querySelector('[data-article-table-of-contents] summary')
        if (toc) {
            toc.click()
        }
    })
}

document.querySelector('.js-toggle-event-dates')?.addEventListener('click', function (e) {
    e.preventDefault()

    const eventDates = document.getElementById('event-dates')
    const eventsDateNext = document.getElementById('events-date-next')
    const icon = this.querySelector('i')

    if (!checkVisibility(eventDates)) {
        showBlind(eventDates, 650)
        // @TODO: This animation is not working as expected
        showBlind(eventsDateNext, 650, 'none')
    } else {
        eventDates.style = {}
        eventDates.style.display = 'none'

        eventsDateNext.style = {}
        eventsDateNext.style.display = 'block'
    }

    icon.classList.toggle('rotate-180')
})

/**
 * Add the .referral-page class to external links
 */
document.querySelectorAll('.article-profile a').forEach((link) => {
    function isLinkExternal() {
        return (
            link.href &&
            link.target === '_blank' &&
            (!link.dataset || !link.dataset.action) &&
            !new RegExp(location.host).test(link.href) &&
            new RegExp(/^(https?:)?\/\//).test(link.href)
        )
    }

    if (!isLinkExternal()) {
        return
    }

    link.classList.add('referral-page')
})

initStickyQuickLinks()
